import io from 'socket.io-client'
import Vue from 'vue'

export function initialSocket (route, path) {
  const initial = io(`${process.env.VUE_APP_API_URL}/v1/${route}`, {
    path: `/${path}`,
    transports: ['websocket', 'polling'],
    autoConnect: true
  })

  return initial
}

const socket = io(process.env.VUE_APP_API_URL, {
  transports: ['websocket', 'polling'],
  autoConnect: true
})

Vue.prototype.$socket = socket

export default socket
